import React from 'react'
import { ArrowSmUpIcon, SwitchVerticalIcon } from '@heroicons/react/outline'
import clsx from 'clsx'
import { isNil } from 'lodash'
import RadioButton from '../../RadioButton/RadioButton'
import CheckBox from '../../CheckBox/CheckBox'
import PropTypes from 'prop-types'
import { handleToggleSelect } from './tableUtils'

export const RenderSortButton = (itemField, columnData) => {
    if (itemField === 'select' || itemField === 'options') return null

    return columnData?.sorting === 'none' ? (
        <SwitchVerticalIcon
            className={clsx(
                'ml-2 absolute left-0 top-3 invisible font-normal stroke-2 stroke-current group-hover:visible w-6 transition-transform text-textDarkerGray cursor-pointer transform',
            )}
        />
    ) : (
        <ArrowSmUpIcon
            className={clsx(
                'ml-2 absolute left-0 top-3 font-normal stroke-2 stroke-current w-6 transition-transform text-textDarkerGray cursor-pointer transform',
                columnData?.sorting === 'desc' ? 'rotate-180' : 'rotate-0',
            )}
        />
    )
}

export const RenderSelect = ({
    customId,
    exists,
    selectedItems,
    onSelectItem,
    isInCard,
    isMobile,
    isTablet,
    getRows,
    singleSelection,
}) => {
    const handleSelect = () =>
        handleToggleSelect({
            customId,
            exists,
            singleSelection,
            selectedItems,
            onSelectItem,
            rows: getRows?.() ?? [],
        })

    return isInCard ? (
        <div onClick={event => event.stopPropagation()}>
            <RadioButton
                className={isMobile || isTablet ? 'mr-2' : ''}
                value={true}
                checked={!isNil(exists)}
                onChange={handleSelect}
            />
        </div>
    ) : (
        (selectedItems,
        (
            <div onClick={event => event.stopPropagation()}>
                <CheckBox
                    defaultChecked={exists}
                    onChange={handleSelect}
                    className={isMobile || (isTablet && 'mr-2')}
                />
            </div>
        ))
    )
}

RenderSelect.propTypes = {
    customId: PropTypes.any,
    selectedItems: PropTypes.array,
    onSelectItem: PropTypes.func,
    exists: PropTypes.any,
    isInCard: PropTypes.bool,
    isMobile: PropTypes.bool,
    isTablet: PropTypes.bool,
    getRows: PropTypes.func,
    singleSelection: PropTypes.bool,
}
